import { applyAction } from "./appliers";
import type { YachtAction, YachtGameState, YachtReducerResult } from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: YachtGameState,
  action: YachtAction,
): YachtReducerResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return {
      valid: false,
      state,
      error: validation.error ?? "Validation failed",
      details: validation.details,
    };
  }

  return {
    valid: true,
    state: applyAction(state, action),
  };
}
